import { Box, Button, ButtonProps, Center, Container, Flex, Heading, Tab, TabList, TabPanel, TabPanels, Tabs, useDisclosure } from "@chakra-ui/react";
import { ReactElement, useEffect, useState } from "react";
import LogosTable from "../../components/table";
import Layout from "../layouts";
import OrderService from "services/orders/order-service";
import { useNavigate } from "react-router-dom";
import LogosTablePagination from "../../components/table/table-pagination";
import { usePaginator } from "chakra-paginator";
import DownloadReportDialog from "./download-report";
import LogosTableSearch from "../../components/table/table-search";

const OrderScene = (): ReactElement => {
    const navigate = useNavigate();
    const [tabIndex, setTabIndex] = useState<number>(0);
    const [orders, setOrders] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [totalOrder, setTotalOrder] = useState<number>(0);
    const { isOpen: isShowDownloadSalesReportDialog, onOpen: onShowDownloadSalesReportDialog, onClose: onCloseDownloadSalesReportDialog } = useDisclosure();
    const [searchKey, setSearchKey] = useState<string>("");

    const {
        pagesQuantity,
        currentPage,
        setCurrentPage,
        pageSize,
        setPageSize,
        offset
    } = usePaginator({
        total: totalOrder,
        initialState: {
            pageSize: 20,
            currentPage: 1
        }
    });

    const generateStatusByTabIndex = (tabIndex: number) => {
        let status = 0;
        switch (tabIndex) {
            case 0:
                status = 30;
                break;
            case 1:
                status = 10;
                break;
            case 2:
                status = 20;
                break;
            case 3:
                status = 40;
                break;
            case 4:
            default:
                status = 0;
                break;
        }
        return status;
    };

    useEffect(() => {
        setIsLoading(true);
        let status = generateStatusByTabIndex(tabIndex);
        let skipCount = ((currentPage - 1) * pageSize);

        OrderService.GetListOrder(searchKey, status, skipCount, pageSize).then((res: any) => {
            if (res.result) {
                setOrders(res.result.items);
                setTotalOrder(res.result.totalCount);
            }
        }).finally(() => {
            setIsLoading(false);
        });
    }, [tabIndex, currentPage]);

    const handleClickRow = (order: any) => {
        navigate(`/orders/${order.id}`);
    };

    const handlePageChange = (nextPage: number) => {
        setCurrentPage(nextPage);
    };

    const handleSearch = (searchKey: string) => {
        //setIsLoading(true);
        let status = generateStatusByTabIndex(tabIndex);
        let skipCount = ((currentPage - 1) * pageSize);

        OrderService.GetListOrder(searchKey, status, skipCount, pageSize).then((res: any) => {
            if (res.result) {
                setOrders(res.result.items);
                setTotalOrder(res.result.totalCount);
            }
        }).finally(() => {
            //setIsLoading(false);
        });
    };

    const orderTable = () => {
        return (
            <>
                <LogosTableSearch handleSearch={handleSearch} />
                <LogosTable
                    headers={[{ label: 'Invoice #' }, { label: 'Tanggal' }, { label: 'Client' }, { label: 'Produk' }, { label: 'Harga', isNumeric: true }, { label: 'Total Dibayar', isNumeric: true }, { label: 'Metode Pemb.' }, { label: 'Campaign' }, { label: 'Status' }]}
                    rows={[{ propertyName: 'invoiceNo', baseUrl: '/orders/' }, { propertyName: 'creationTime', isDatetime: true }, { propertyName: 'userFullName' }, { propertyName: 'productName' }, { propertyName: 'amount', isNumeric: true }, { propertyName: 'paidAmount', isNumeric: true }, { propertyName: 'paymentMethodString' }, { propertyName: 'utm.source' }, { propertyName: 'statusString' }]}
                    data={orders}
                    onRowClick={handleClickRow}
                />
                <LogosTablePagination currentPage={currentPage} pagesQuantity={pagesQuantity} handlePageChange={handlePageChange} />
            </>
        );
    }

    return (
        <Layout>
            <Container maxWidth={"8xl"} mt={2} mb={5}>
                <Box>
                    <Heading fontSize={'3xl'} fontWeight={"extrabold"}>Orders</Heading>
                </Box>
                <Box mt={4}>
                    <Button onClick={onShowDownloadSalesReportDialog}>Download Laporan Penjualan</Button>
                    {
                        isShowDownloadSalesReportDialog &&
                        <DownloadReportDialog onClose={onCloseDownloadSalesReportDialog} />
                    }
                </Box>
                <Box mt={6}>
                    <Tabs isFitted defaultIndex={tabIndex} index={tabIndex} onChange={(index) => setTabIndex(index)}>
                        <TabList overflowX={'auto'}>
                            <Tab>Lunas</Tab>
                            <Tab>Belum Bayar</Tab>
                            <Tab>Belum Lunas</Tab>
                            <Tab>Batal</Tab>
                            <Tab>Semua</Tab>
                        </TabList>
                        {
                            isLoading &&
                            <Box>Loading...</Box>
                        }
                        {
                            !isLoading &&
                            <TabPanels>
                                <TabPanel px={0} pt={4}>{orderTable()}</TabPanel>
                                <TabPanel px={0} pt={4}>{orderTable()}</TabPanel>
                                <TabPanel px={0} pt={4}>{orderTable()}</TabPanel>
                                <TabPanel px={0} pt={4}>{orderTable()}</TabPanel>
                                <TabPanel px={0} pt={4}>{orderTable()}</TabPanel>
                            </TabPanels>
                        }
                    </Tabs>
                </Box>
            </Container>
        </Layout >
    );
};

export default OrderScene;